import Vue from 'vue'
import withRender from './icon.html'
import './icon.scss'

export default withRender(Vue.extend({

  data() { return { icon: {} } },
  props: {
    ariaHidden: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'sm'
    },
    title: { type: String }
  },
  computed: {
    classes() {
      return [`tt-o-icon--${this.name}`, `tt-o-icon--${this.size}`]
    },
    iconId() {
      return `#tt-icon-${this.name}`
    }
  },
  created() {
    if (!this.ariaHidden && !this.title && process.env.NODE_ENV === 'development') {
      // tslint:disable:next-line no-console
      console.error(`Icon ${this.name} needs a title or ariaHidden to be true`)
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/icon/icon.ts